import React, { PropsWithChildren } from 'react';

import { Box, Spinner } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';

type Props = { name: string; context: string };

/** @deprecated Use `useFeatureFlag` */
export const TestTrackFeatureGate = ({ name, context, children }: PropsWithChildren<Props>) => {
  const { enabled: isFeatureFlagEnabled, loading: isLoading } = useFeatureFlag({ splitName: name, context });

  if (isLoading) {
    return (
      <Box css={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner size="lg" />
      </Box>
    );
  }

  if (isFeatureFlagEnabled) {
    return React.Children.toArray(children).find(
      (child): child is React.ReactElement => React.isValidElement(child) && child.type === TestTrackFeatureGate.True
    );
  }

  return React.Children.toArray(children).find(
    (child): child is React.ReactElement => React.isValidElement(child) && child.type === TestTrackFeatureGate.False
  );
};

TestTrackFeatureGate.True = ({ children }: PropsWithChildren) => <>{children}</>;
TestTrackFeatureGate.False = ({ children }: PropsWithChildren) => <>{children}</>;
